var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffice3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(0, 0, 0, 0.5)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.481 26v-4.923a1 1 0 0 0-1-1H9.52a1 1 0 0 0-1 1V26H0V11a2 2 0 0 1 2-2h19a2 2 0 0 1 2 2v15h-8.519zM3.414 13.426h16.598c.596 0 1.078-.379 1.078-.846 0-.467-.482-.846-1.078-.846H3.414c-.595 0-1.078.379-1.078.846 0 .467.483.846 1.078.846zm0 4.231h16.598c.596 0 1.078-.379 1.078-.846 0-.467-.482-.846-1.078-.846H3.414c-.595 0-1.078.379-1.078.846 0 .467.483.846 1.078.846z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 2.734H5.991V2a2 2 0 0 1 2-2H15a2 2 0 0 1 2 2v.734zm0 1.692V11H5.991V4.426H17zM9.414 8.657h4.598c.596 0 1.078-.379 1.078-.846 0-.467-.482-.846-1.078-.846H9.414c-.595 0-1.078.379-1.078.846 0 .467.483.846 1.078.846z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice3);
export default __webpack_public_path__ + "static/media/office-3.7e6757c8dfe07b30980ccc5711c3d29d.svg";
export { ForwardRef as ReactComponent };